import Axios from 'axios';
import Qs from 'qs';

export default {

  // 话题分页列表
  listPage(
    keyword,
    is_hide,
    category_id,
    community_ids,
    page,
    per_page
  ) {
    return Axios.get('/llhd/api/admin/topic', {
      params: {
        keyword,
        is_hide,
        category_id,
        community_ids,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 话题列表
  list() {
    return Axios.get('/llhd/api/admin/topic/all');
  },

  // 话题添加
  add(
    content,
    category_id,
    community_ids,
    photos,
    content_desc
  ) {
    return Axios.post('/llhd/api/admin/topic', {
      content,
      category_id,
      community_ids,
      photos,
      content_desc
    });
  },

  // 话题编辑
  edit(
    id,
    content,
    category_id,
    community_ids,
    photos,
    content_desc
  ) {
    return Axios.put(`/llhd/api/admin/topic/${id}`, {
      content,
      category_id,
      community_ids,
      photos,
      content_desc
    });
  },

  // 话题删除
  del(
    ids
  ) {
    return Axios.delete('/llhd/api/admin/topic', {
      data: {
        ids
      }
    });
  },

  // 话题详情
  info(
    community_id,
    id,
    page,
    per_page
  ) {
    return Axios.get(`/llhd/api/admin/topic/${id}`, {
      params: {
        community_id,
        page,
        per_page
      }
    });
  },

  // 话题启用
  enable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/topic/${id}/hide`, {
      is_hide: 0
    })
  },

  // 话题禁用
  disable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/topic/${id}/hide`, {
      is_hide: 1
    })
  },

  // 话题添加帖子
  addInvitation(
    id,
    content,
    photos
  ) {
    return Axios.post(`/llhd/api/admin/topic/${id}/posts`, {
      content,
      photos
    });
  }

}